module.exports = __webpack_public_path__ + "static/media/louis-hansel-7_epF0UqeEs-unsplash.cdc5dba5.jpg";